// The backend's `typ_code` taxonomy is much finer than is useful for browsing
// (kraj, statutarni_mesto, mesto, mestys, obec, mestska_cast, mestsky_obvod,
// parlament, …) — grouping by it directly produces several one-item sections
// (e.g. "Parlament", "Hlavní město") that each cost a full section for a
// single card. Collapse it instead into three browsing-sized buckets: every
// real territorial government is a "city/municipality" regardless of its
// legal tier, regions stay their own thing, and non-municipal bodies (just
// the national parliament today) get a distinct, deliberately last group.
export const BROWSE_GROUPS = ["kraj", "mesto", "national"] as const;
export type BrowseGroup = typeof BROWSE_GROUPS[number];

const NATIONAL_TYPE_CODES = new Set(["parlament"]);

export const resolveBrowseGroup = (typCode: string): BrowseGroup => {
    if (typCode === "kraj") {
        return "kraj";
    }
    if (NATIONAL_TYPE_CODES.has(typCode)) {
        return "national";
    }
    return "mesto";
};
